import { DefaultState, DropdownItem } from 'store/types';

export const EXTERNAL_API_CALLS_FILTERS_REQUEST = 'EXTERNAL_API_CALLS_FILTERS_REQUEST';
export const EXTERNAL_API_CALLS_FILTERS_SUCCESS = 'EXTERNAL_API_CALLS_FILTERS_SUCCESS';
export const EXTERNAL_API_CALLS_FILTERS_FAILURE = 'EXTERNAL_API_CALLS_FILTERS_FAILURE';

export interface GetExternalCallsFiltersData {
  endpoints: Array<DropdownItem>;
}

export type GetExternalCallsFiltersState = DefaultState & {
  contents?: GetExternalCallsFiltersData;
};

interface GetExternalCallsFiltersRequest {
  type: typeof EXTERNAL_API_CALLS_FILTERS_REQUEST;
}

interface GetExternalCallsFiltersSuccess {
  type: typeof EXTERNAL_API_CALLS_FILTERS_SUCCESS;
  contents: GetExternalCallsFiltersData;
}

interface GetExternalCallsFiltersFailure {
  type: typeof EXTERNAL_API_CALLS_FILTERS_FAILURE;
}

export type GetExternalCallsFiltersActionTypes =
  | GetExternalCallsFiltersRequest
  | GetExternalCallsFiltersSuccess
  | GetExternalCallsFiltersFailure;
